import styled from 'styled-components';

import media from '../../styles/media.style';
import { BLACK, MOBILE_PADDING, SCREEN_LOCKUP_WIDTH, BG_GRAY, PAGE_WIDTH } from '../../styles/variables.style';

export const Section = styled.section`
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 ${MOBILE_PADDING}px 35px;
  background: ${BG_GRAY.COMMON_1};
  width: 100%;
  margin: 0 auto;
  max-width: ${PAGE_WIDTH}px;

  ${media.tabletL`
    padding: 0 0 9em;
    background: linear-gradient(to top, ${BG_GRAY.COMMON_1} 0%, ${BG_GRAY.COMMON_1} 75%, #fff 75%, #fff 100%);
  `};

  & > div + div {
    margin-top: 3em;
  }
`;

export const Procedure = styled.div`
  width: 100%;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  margin: 0 auto;
`;

export const Container = styled.div`
  margin-top: -4.4em;
  max-width: 100%;
  width: 100%;

  ${media.tabletL`
    display: flex;
    margin-top: -5.2em;
  `};
`;

export const Title = styled.h5`
  font-size: 16px;
  font-weight: 800;
  text-transform: uppercase;
  color: ${BLACK};

  ${media.tabletL`
    font-size: 19px;
  `};
`;

export const Item = styled.div`
  max-width: 100%;
  position: relative;
  flex: 1;

  &:not(:last-child) {
    padding-right: 13px;
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: auto;
`;

export const TextContainer = styled.div`
  width: 100%;
`;

export const ItemTitle = styled.h5`
  font-size: 16px;
  font-weight: 400;
  color: ${BLACK};
  text-align: right;
  line-height: 1.14;
  letter-spacing: 0.5px;
  text-transform: uppercase;

  ${media.tabletL`
    font-size: 19px;
  `};
`;

export const ItemDescription = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: ${BLACK};
  line-height: 1.25;

  ${media.tabletL`
    font-size: 19px;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/StylesLooksHowto/StylesLooksHowto.style.js